"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointMap = exports.default = void 0;
var endpointMap = {
    ar: {
        ReportAViolationStrings: "translation-ar.json"
    },
    "ar-AE": {
        ReportAViolationStrings: "translation-ar.json"
    },
    bn: {
        ReportAViolationStrings: "translation-bn.json"
    },
    "bn-IN": {
        ReportAViolationStrings: "translation-bn.json"
    },
    cs: {
        ReportAViolationStrings: "translation-cs.json"
    },
    "cs-CZ": {
        ReportAViolationStrings: "translation-cs.json"
    },
    da: {
        ReportAViolationStrings: "translation-da.json"
    },
    "da-DK": {
        ReportAViolationStrings: "translation-da.json"
    },
    de: {
        ReportAViolationStrings: "translation-de.json"
    },
    "de-DE": {
        ReportAViolationStrings: "translation-de.json"
    },
    en: {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-AE": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-AU": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-CA": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-GB": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-IE": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-IN": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-SG": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-US": {
        ReportAViolationStrings: "translation-en.json"
    },
    "en-ZA": {
        ReportAViolationStrings: "translation-en.json"
    },
    es: {
        ReportAViolationStrings: "translation-es.json"
    },
    "es-ES": {
        ReportAViolationStrings: "translation-es.json"
    },
    "es-MX": {
        ReportAViolationStrings: "translation-es.json"
    },
    "es-US": {
        ReportAViolationStrings: "translation-es.json"
    },
    fr: {
        ReportAViolationStrings: "translation-fr.json"
    },
    "fr-BE": {
        ReportAViolationStrings: "translation-fr.json"
    },
    "fr-CA": {
        ReportAViolationStrings: "translation-fr.json"
    },
    "fr-FR": {
        ReportAViolationStrings: "translation-fr.json"
    },
    he: {
        ReportAViolationStrings: "translation-he.json"
    },
    "he-IL": {
        ReportAViolationStrings: "translation-he.json"
    },
    hi: {
        ReportAViolationStrings: "translation-hi.json"
    },
    "hi-IN": {
        ReportAViolationStrings: "translation-hi.json"
    },
    id: {
        ReportAViolationStrings: "translation-id.json"
    },
    "id-ID": {
        ReportAViolationStrings: "translation-id.json"
    },
    it: {
        ReportAViolationStrings: "translation-it.json"
    },
    "it-IT": {
        ReportAViolationStrings: "translation-it.json"
    },
    ja: {
        ReportAViolationStrings: "translation-ja.json"
    },
    "ja-JP": {
        ReportAViolationStrings: "translation-ja.json"
    },
    kn: {
        ReportAViolationStrings: "translation-kn.json"
    },
    "kn-IN": {
        ReportAViolationStrings: "translation-kn.json"
    },
    ko: {
        ReportAViolationStrings: "translation-ko.json"
    },
    "ko-KR": {
        ReportAViolationStrings: "translation-ko.json"
    },
    ml: {
        ReportAViolationStrings: "translation-ml.json"
    },
    "ml-IN": {
        ReportAViolationStrings: "translation-ml.json"
    },
    mr: {
        ReportAViolationStrings: "translation-mr.json"
    },
    "mr-IN": {
        ReportAViolationStrings: "translation-mr.json"
    },
    nl: {
        ReportAViolationStrings: "translation-nl.json"
    },
    "nl-BE": {
        ReportAViolationStrings: "translation-nl.json"
    },
    "nl-NL": {
        ReportAViolationStrings: "translation-nl.json"
    },
    pl: {
        ReportAViolationStrings: "translation-pl.json"
    },
    "pl-PL": {
        ReportAViolationStrings: "translation-pl.json"
    },
    pt: {
        ReportAViolationStrings: "translation-pt.json"
    },
    "pt-BR": {
        ReportAViolationStrings: "translation-pt.json"
    },
    "pt-PT": {
        ReportAViolationStrings: "translation-pt.json"
    },
    sv: {
        ReportAViolationStrings: "translation-sv.json"
    },
    "sv-SE": {
        ReportAViolationStrings: "translation-sv.json"
    },
    ta: {
        ReportAViolationStrings: "translation-ta.json"
    },
    "ta-IN": {
        ReportAViolationStrings: "translation-ta.json"
    },
    te: {
        ReportAViolationStrings: "translation-te.json"
    },
    "te-IN": {
        ReportAViolationStrings: "translation-te.json"
    },
    th: {
        ReportAViolationStrings: "translation-th.json"
    },
    "th-TH": {
        ReportAViolationStrings: "translation-th.json"
    },
    tr: {
        ReportAViolationStrings: "translation-tr.json"
    },
    "tr-TR": {
        ReportAViolationStrings: "translation-tr.json"
    },
    und: {
        ReportAViolationStrings: "translation.json"
    },
    zh: {
        ReportAViolationStrings: "translation-zh.json"
    },
    "zh-CN": {
        ReportAViolationStrings: "translation-zh.json"
    },
    "zh-TW": {
        ReportAViolationStrings: "translation-zh.json"
    }
};
exports.endpointMap = endpointMap;
var arbManifest = {
    endpointMap: endpointMap
};
exports.default = arbManifest;
